import PortalIdParser from 'PortalIdParser';
import { Avatar } from 'avatar-components/Avatar';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import UsageTracker from '../../../../utils/UsageTracker';
import { PROFILE_URL_FRAGMENT } from '../../../../constants/Navigation.legacy';
import { useUserInfo } from '../../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserAvatarLink = ({
  userEmail,
  userName,
  userId,
  displayAvatar = true,
  position
}) => {
  var _currentUser$user;
  const {
    userInfo: currentUser
  } = useUserInfo();
  const handleProfileClick = () => {
    UsageTracker.track('teamInteraction', Object.assign({
      action: 'profile-link-click'
    }, position !== undefined && {
      position
    }));
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    children: [displayAvatar && /*#__PURE__*/_jsx(Box, {
      shrink: 0,
      children: /*#__PURE__*/_jsx(Avatar, {
        lookup: {
          type: 'hubSpotUserEmail',
          primaryIdentifier: userEmail
        },
        portalId: PortalIdParser.get(),
        size: "xs"
      })
    }), /*#__PURE__*/_jsx(ACRouterLink, {
      onClick: handleProfileClick,
      to: userId === (currentUser === null || currentUser === void 0 || (_currentUser$user = currentUser.user) === null || _currentUser$user === void 0 ? void 0 : _currentUser$user.id) ? PROFILE_URL_FRAGMENT : `${PROFILE_URL_FRAGMENT}/${userId}`,
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: userName || userEmail
      })
    })]
  });
};
export default UserAvatarLink;